import React, { useEffect, useState } from "react";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import ModalHeader from "@/shared/components/ui/Modal/ModalHeader";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";

const SOURCE_OPTIONS = [
  ["website_signup_form", "Website signup form"],
  ["customer_requested_emails", "Customer requested emails"],
  ["existing_business_relationship", "Existing business relationship"],
  ["imported_consent_record", "Imported consent record"],
  ["manual_confirmation", "Manual confirmation"],
  ["other", "Other"],
  ["unsubscribe_link", "Unsubscribe link"],
];

const ConsentUpdateModal = ({
  isOpen,
  contacts = [],
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const [status, setStatus] = useState("consented");
  const [source, setSource] = useState("manual_confirmation");

  useEffect(() => {
    if (!isOpen) return;
    const contact = contacts.length === 1 ? contacts[0] : null;
    setStatus(contact?.emailConsentStatus || "consented");
    setSource(contact?.emailConsentSource || "manual_confirmation");
  }, [contacts, isOpen]);

  const handleSubmit = () => {
    onSubmit({
      status,
      source: status === "unknown" ? null : source,
    });
  };

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} width="460px" className="!p-0">
      <div className="flex w-full flex-col gap-5 p-6">
        <ModalHeader
          title={contacts.length === 1 ? "Update email consent" : "Update email consent for contacts"}
          onClose={onClose}
        />
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {contacts.length === 1
            ? `Update consent for ${contacts[0]?.name || contacts[0]?.email || "this contact"}.`
            : `This will update ${contacts.length} selected contacts.`}
        </p>

        <label className="flex flex-col gap-1.5 text-xs font-medium text-gray-600 dark:text-gray-300">
          Consent status
          <select
            value={status}
            onChange={(event) => setStatus(event.target.value)}
            className="h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm font-normal text-gray-700 outline-none focus:border-secondary dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
          >
            <option value="consented">Consented</option>
            <option value="unsubscribed">Unsubscribed</option>
            <option value="unknown">Unknown</option>
          </select>
        </label>

        {status !== "unknown" && (
          <label className="flex flex-col gap-1.5 text-xs font-medium text-gray-600 dark:text-gray-300">
            Consent source
            <select
              value={source}
              onChange={(event) => setSource(event.target.value)}
              className="h-9 rounded-lg border border-gray-300 bg-white px-2.5 text-sm font-normal text-gray-700 outline-none focus:border-secondary dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
            >
              {SOURCE_OPTIONS.map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </label>
        )}

        <div className="flex justify-end gap-2 border-t border-gray-100 pt-4 dark:border-gray-800">
          <SecondaryButton title="Cancel" onClick={onClose} disabled={isSubmitting} />
          <PrimaryButton
            onClick={handleSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
            startContent={false}
          >
            Save consent
          </PrimaryButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default ConsentUpdateModal;
